/**
 * 客户端与服务端之间的线上协议。
 *
 * 这个文件是**两端唯一的契约来源**：服务端的 net/socket.ts 与网页端都从这里
 * 取类型，所以任何一端改了事件名或载荷形状，另一端立刻编译失败。
 *
 * 一条贯穿全文的原则：**这里出现的每个载荷都必须是「可以给收信人看」的。**
 * 局面数据只有两个合法出口，都在服务端房间层：
 *   ① `view` —— 按席位过滤后的私有视图，**每席一份，绝不共用一份广播**；
 *   ② `reveal` —— 对局真正结束后的摊牌，那时才没有秘密可言。
 * 除此之外的事件（roomInfo / chat / events / clock）载荷里只有公开信息，
 * 因此可以用房间广播发。往这些载荷上加字段前，先确认它对三个人都该可见。
 */
/** 手机上一点即发的预设短语，不用打字 */
export const CHAT_PRESETS = [
    '我不信',
    '你完了',
    '随便你',
    '想清楚点',
    '😂',
    '🤔',
    '😱',
    '👏',
];
